import {
  IconButton,
  InputAdornment,
  TextField,
} from '@mui/material'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import { useState } from 'react'


const CustomInput = ({ type, label, validate, ...props }) => {
  const [inputType, setType] = useState(type ? type : 'text')
  const [err, setErr] = useState(null)

  const onBlur = (e) => {
    if (validate) {
      const validationString = validate()
      if (validationString !== true) {
        setErr(validationString)
      } else setErr(null)
    }
  }
  const onInput = () => {
    setErr(null)
  }
  return (
    <TextField
      // sx={{
      //   '& .MuiOutlinedInput-root': {
      //     '& fieldset': { borderColor: 'rgba(255, 255, 255, 1)' }, // Default border color
      //     '&:hover fieldset': { borderColor: 'rgba(255, 255, 255, 1)' }, // Hover state
      //     '&.Mui-focused fieldset': { borderColor: 'rgba(255, 255, 255, 1)' }, // Focus state
      //   },
      //   '& label': { color: 'rgba(255, 255, 255, 1)' }, // Label color
      //   '& label.Mui-focused': { color: 'rgba(255, 255, 255, 1)' }, // Focused label color
      //   '& .MuiInputBase-input': { color: 'rgba(255, 255, 255, 1)' }, // Text color inside input
      // }}


      onInput={onInput}
      fullWidth
      margin="dense"

      onBlur={onBlur}
      id={label}
      autoComplete={false}
      label={label}

      InputProps={{



        endAdornment:
          type == 'password' ? <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={() => {
                setType(inputType === 'password' ? 'text' : 'password')
              }}
              sx={{ color: 'rgba(255, 255, 255, 1)' }}
              edge="end"
            >
              {inputType === 'password' ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment> : <></>

      }}
      {...props}
      type={inputType}
      helperText={err ?? props.helperText}
      error={err != null}

    />
  )
}
export default CustomInput